export default __webpack_public_path__ + "static/media/down_corner_orange.9f146251.svg";